import state from './authentication.state'
import mutations from './authentication.mutations'
import actions from './authentication.actions'
import getters from './authentication.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
